(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $43ac1e1ebef8b5d5$exports = {};
$parcel$extendImportMap({
    "04kb3": "senda-hero.3491fc4d.avif",
    "boTIU": "senda-hero.6521b704.webp",
    "5eJDA": "senda-hero.da2a3d6b.jpeg",
    "1TKYL": "parc-central-hero.1d8051ae.avif",
    "2Qid5": "parc-central-hero.38c21b10.webp",
    "1FU0R": "parc-central-hero.f48c5d87.jpeg",
    "Q938R": "xana-hero.a7980dd6.avif",
    "fmxem": "xana-hero.01e22d0e.webp",
    "2AMaf": "xana-hero.c083fd0f.jpeg"
});

// LOGO ANIMATION
var $4307343ef31ccaa2$var$_document_querySelector;
var $4307343ef31ccaa2$var$stage = document.getElementById('stage');
var $4307343ef31ccaa2$var$hasSeenIntro = sessionStorage.getItem('introSeen');
if ($4307343ef31ccaa2$var$stage) {
    if ($4307343ef31ccaa2$var$hasSeenIntro) {
        // The user has already seen the animation in this session —> skip it
        $4307343ef31ccaa2$var$stage.remove();
        document.body.classList.remove('is-loading');
    } else {
        // First time or refresh —> show the animation
        sessionStorage.setItem('introSeen', 'true');
        $4307343ef31ccaa2$var$stage.addEventListener('animationend', function(e) {
            if (e.animationName === 'hideIntro') {
                $4307343ef31ccaa2$var$stage.remove();
                document.body.classList.remove('is-loading');
            }
        });
    }
    // This IIFE calculates the necessary scale for the fill element to cover the entire stage during the animation. 
    // It also updates this calculation on window resize to ensure the animation remains consistent across different screen sizes.
    (function() {
        var fill = document.getElementById('fill');
        if (!fill) return; // If the stage has already been removed, do nothing.
        // Calculates the scale-end for the fill based on the stage size and the fill's actual size in px (respecting rem units).
        function calcFillScale() {
            var maxDim = Math.max($4307343ef31ccaa2$var$stage.offsetWidth, $4307343ef31ccaa2$var$stage.offsetHeight);
            var fillSize = fill.offsetWidth; // Reads the actual size in px, respecting rem units.
            fill.style.setProperty('--scale-end', Math.ceil(maxDim * 1.5 / fillSize));
        }
        calcFillScale();
        window.addEventListener('resize', calcFillScale);
    })();
}
// Page enter animation — only if the user has already seen the intro
if ($4307343ef31ccaa2$var$hasSeenIntro) ($4307343ef31ccaa2$var$_document_querySelector = document.querySelector('.page')) === null || $4307343ef31ccaa2$var$_document_querySelector === void 0 ? void 0 : $4307343ef31ccaa2$var$_document_querySelector.classList.add('page-enter');
// CURSOR PREVIEW
// 1. Selección de elementos
var $4307343ef31ccaa2$var$items = document.querySelectorAll(".archive-list-item");
var $4307343ef31ccaa2$var$preview = document.querySelector(".cursor-preview");
var $4307343ef31ccaa2$var$previewPicture = $4307343ef31ccaa2$var$preview === null || $4307343ef31ccaa2$var$preview === void 0 ? void 0 : $4307343ef31ccaa2$var$preview.querySelector("picture");
var $fcb5d935e330509c$exports = {};
$fcb5d935e330509c$exports = $parcel$resolve("04kb3");


var $7f5619638b5900e5$exports = {};
$7f5619638b5900e5$exports = $parcel$resolve("boTIU");


var $3899f22a0e8d2555$exports = {};
$3899f22a0e8d2555$exports = $parcel$resolve("5eJDA");


var $c812d3ed65097f15$exports = {};
$c812d3ed65097f15$exports = $parcel$resolve("1TKYL");


var $c32c8c7f601c099c$exports = {};
$c32c8c7f601c099c$exports = $parcel$resolve("2Qid5");


var $39febe9b936f523e$exports = {};
$39febe9b936f523e$exports = $parcel$resolve("1FU0R");


var $2369c250ffa6a36f$exports = {};
$2369c250ffa6a36f$exports = $parcel$resolve("Q938R");


var $e7084b89f9b6e13e$exports = {};
$e7084b89f9b6e13e$exports = $parcel$resolve("fmxem");


var $c745f35733e559ee$exports = {};
$c745f35733e559ee$exports = $parcel$resolve("2AMaf");


// 2. Definición de imágenes
var $4307343ef31ccaa2$var$images = {
    senda: {
        avif: new URL($fcb5d935e330509c$exports).href,
        webp: new URL($7f5619638b5900e5$exports).href,
        jpg: new URL($3899f22a0e8d2555$exports).href
    },
    parc: {
        avif: new URL($c812d3ed65097f15$exports).href,
        webp: new URL($c32c8c7f601c099c$exports).href,
        jpg: new URL($39febe9b936f523e$exports).href
    },
    xana: {
        avif: new URL($2369c250ffa6a36f$exports).href,
        webp: new URL($e7084b89f9b6e13e$exports).href,
        jpg: new URL($c745f35733e559ee$exports).href
    }
};
// 3. Función para actualizar el picture completo
function $4307343ef31ccaa2$var$updatePicture(imgSet) {
    if (!$4307343ef31ccaa2$var$previewPicture) return;
    // Reconstruye el contenido del <picture> completo
    $4307343ef31ccaa2$var$previewPicture.innerHTML = '\n        <source srcset="'.concat(imgSet.avif, '" type="image/avif">\n        <source srcset="').concat(imgSet.webp, '" type="image/webp">\n        <img src="').concat(imgSet.jpg, '" alt="">\n    ');
}
// 4. Precarga
Object.values($4307343ef31ccaa2$var$images).forEach(function(imgSet) {
    // Precarga jpg como fallback fiable
    var img = new Image();
    img.src = imgSet.jpg;
});
// 5. Eventos
if ($4307343ef31ccaa2$var$preview && $4307343ef31ccaa2$var$previewPicture) $4307343ef31ccaa2$var$items.forEach(function(item) {
    item.addEventListener("mouseenter", function() {
        var key = item.dataset.image;
        var imgSet = $4307343ef31ccaa2$var$images[key];
        if (!imgSet) return;
        $4307343ef31ccaa2$var$updatePicture(imgSet);
        $4307343ef31ccaa2$var$preview.style.opacity = "1";
        $4307343ef31ccaa2$var$preview.style.transform = "scale(1)";
    });
    item.addEventListener("mouseleave", function() {
        $4307343ef31ccaa2$var$preview.style.opacity = "0";
        $4307343ef31ccaa2$var$preview.style.transform = "scale(0.8)";
    });
    item.addEventListener("mousemove", function(e) {
        var offset = 20;
        $4307343ef31ccaa2$var$preview.style.left = e.clientX + offset + "px";
        $4307343ef31ccaa2$var$preview.style.top = e.clientY + offset + "px";
    });
});
// console.log("Preview ready");
// PAGE ANIMATION
// import { gsap } from "gsap";
// window.addEventListener("load", () => {
//   gsap.fromTo(".page",
//     { y: "10%", opacity: 0 },
//     { y: "0%", opacity: 1, duration: 0.8, ease: "power2.out" }
//   );
// });
// DETAILS TOGGLE
document.querySelectorAll("details").forEach(function(detail) {
    var summary = detail.querySelector("summary");
    detail.addEventListener("toggle", function() {
        summary.textContent = detail.open ? "Read less" : "Read more";
    });
});

})();
//# sourceMappingURL=repo.c57f72ba.js.map
